import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import Returns from '@/views/Returns.vue'
import Replen from '@/views/Replen.vue'
import Orders from '@/views/Orders.vue'
import BXZ from '@/views/BXZ.vue'
import SPH from '@/views/SPH.vue'
import Ecom from '@/views/Ecom.vue'
import Barcodes from "@/views/Barcodes.vue"
import OHU from "@/views/OHU.vue"

const routes = [
  {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/returns',
      name: 'returns',
      component: Returns,
    },
    {
      path: '/replen',
      name: 'replen',
      component: Replen,
    },
    {
      path: '/orders',
      name: 'orders',
      component: Orders,
    },
    {
      path: '/bxz',
      name: 'bxz',
      component: BXZ,
    },
    {
      path: '/sph',
      name: 'sph',
      component: SPH,
    },
    {
      path: '/ecom',
      name: 'ecom',
      component: Ecom,
    },
    {
      path: '/barcodes',
      name: 'barcodes',
      component: Barcodes,
    },
    {
      path: '/ohu',
      name: 'ohu',
      component: OHU,
    }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
